module.exports = __webpack_public_path__ + "static/media/project-avatar.66a9d719.svg";